import { Injectable, inject } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslateService } from "@ngx-translate/core";

/** Material paginator labels follow the active ngx-translate language. */
@Injectable()
export class TranslateMatPaginatorIntl extends MatPaginatorIntl {
  private _translate = inject(TranslateService);

  constructor() {
    super();
    this._apply();
    this._translate.onLangChange.subscribe(() => this._apply());
  }

  private _apply(): void {
    this.itemsPerPageLabel = this._translate.instant("paginatorItemsPerPage");
    this.nextPageLabel = this._translate.instant("paginatorNextPage");
    this.previousPageLabel = this._translate.instant("paginatorPreviousPage");
    this.firstPageLabel = this._translate.instant("paginatorFirstPage");
    this.lastPageLabel = this._translate.instant("paginatorLastPage");
    this.changes.next();
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this._translate.instant("paginatorOf")} ${length}`;
    }
    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return `${startIndex + 1} – ${endIndex} ${this._translate.instant("paginatorOf")} ${length}`;
  };
}
